import React, { useState } from 'react';
//import './navbar.css';
//import { Link } from "react-router-dom"
import {  ListGroup, Form } from 'react-bootstrap';
const { Tipologia_Aziende, Tipologia_Aziende_lungo } = require('../Funzioni_comuni_tipologia_aziende')



const Scelta_tipologia_azienda = (props) => {

    const lista = Tipologia_Aziende()
    const lista_lunga = Tipologia_Aziende_lungo()

    //    const [somma, calcola_somma] = useState('');

    const handleChange = e => {
        e.persist();
        console.log(e.target.value);

        props.setInput(prevState => ({
        ...prevState,
        tipologia: e.target.value
        }));
    };

    //        {/* idroslab  */} utilizzo del radio button con bootstrap


    return (
    <>
        <Form.Label column sm="2">
             
        </Form.Label>

        <ListGroup>
     

        <Form.Group  className='d-flex justify-content-between' controlId={'tipologia'} >

        {lista.map(function (item_aux, index2) {
            {
                //                        console.log(item)
                return <>
                    <Form.Check

                    value={item_aux}
                    type="radio"
                    aria-label="radio 1"
                    label={lista_lunga[index2]}
                    onChange={handleChange}
                    checked={props.input.tipologia == item_aux}
                    />
        
                </>
            }
        })
        }
        </Form.Group>
    
                                

        </ListGroup>
    
    </>
    )
}
export default Scelta_tipologia_azienda;